import React from "react";
import * as ReactDOMServer from "react-dom/server";
import L from "leaflet";

export const renderCurrentPoint = () => {
  // eslint-disable-next-line new-cap
  return new L.divIcon({
    html: ReactDOMServer.renderToString(
      <div className="relative">
        <div
          className="absolute left-1.5 -top-4.5"
          style={{
            borderLeft: "6px solid transparent",
            borderRight: "6px solid transparent",
            borderTop: "6px solid black",
          }}
        />
        <div className="absolute -top-10 -left-6 px-2 py-1 bg-black rounded">
          <p className="font-normal text-center text-white font-aileron text-10 whitespace-nowrap">
            You are here
          </p>
        </div>

        <div className="bg-primary-20 absolute -top-2 -left-2 rounded-full w-10 h-10 opacity-40" />
        {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="42"
            fill="none"
            viewBox="0 0 40 42"
          >
            <g filter="url(#filter0_f_3482_20243)">
              <path
                fill="#000"
                fillOpacity="0.26"
                d="M4.45 13.91c3.656-15.892 27.463-15.874 31.1.018 2.134 9.322-3.73 17.212-8.87 22.093-5.567 5.287-7.793 5.324-13.378 0C8.18 31.141 2.317 23.231 4.45 13.91z"
              />
            </g>
            <path
              fill="#EAB726"
              stroke="#EAB726"
              strokeWidth="1.5"
              d="M6.034 14.15C9.316-.283 30.7-.267 33.966 14.167 35.883 22.633 30.617 29.8 26 34.233c-5 4.802-7 4.835-12.017 0-4.6-4.433-9.866-11.616-7.95-20.083z"
            />
            <defs>
              <filter
                id="filter0_f_3482_20243"
                width="34.2"
                height="40.2"
                x="2.9"
                y="0.9"
                colorInterpolationFilters="sRGB"
                filterUnits="userSpaceOnUse"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  result="effect1_foregroundBlur_3482_20243"
                  stdDeviation="0.55"
                />
              </filter>
            </defs>
          </svg> */}

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="26"
          fill="none"
          viewBox="0 0 24 26"
        >
          <g filter="url(#filter0_d_10193_607)">
            <ellipse cx="12" cy="23" fill="#000" opacity="0.4" rx="4" ry="1" />
            <path
              fill="#000"
              d="M12.75 7.688a.42.42 0 0 0-.422-.422h-.656a.42.42 0 0 0-.422.422v13.76c0 .2.04.397.117.58l.472 1.125a.185.185 0 0 0 .255.07.2.2 0 0 0 .067-.07l.472-1.125c.077-.183.117-.38.117-.58z"
            />
            <path
              fill="#085054"
              stroke="#085054"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M12 7.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_10193_607"
              width="26"
              height="26"
              x="0"
              y="0"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feMorphology
                in="SourceAlpha"
                radius="2"
                result="effect1_dropShadow_10193_607"
              />
              <feOffset dx="1" dy="1" />
              <feGaussianBlur stdDeviation="1.5" />
              <feColorMatrix values="0 0 0 0 0.482891 0 0 0 0 0.482891 0 0 0 0 0.482891 0 0 0 1 0" />
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_10193_607"
              />
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_10193_607"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
        {/* </div> */}
      </div>,
    ),
  });
};

export const renderPolygonPoint = () => {
  // eslint-disable-next-line new-cap
  return new L.divIcon({
    html: ReactDOMServer.renderToString(
      <div className="absolute ">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          fill="none"
          viewBox="0 0 24 25"
        >
          <g strokeWidth="1.5" filter="url(#filter0_d_10174_96687)">
            <path
              fill="#085054"
              stroke="#085054"
              d="M3.62 8.49c1.97-8.66 14.8-8.65 16.76.01 1.15 5.08-2.01 9.38-4.78 12.04a5.193 5.193 0 0 1-7.21 0c-2.76-2.66-5.92-6.97-4.77-12.05Z"
            />
            <path
              stroke="#FAFAFA"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m9.25 11.5 1.5 1.5 4-4"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_10174_96687"
              width="26"
              height="26"
              x="0"
              y="0"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feMorphology
                in="SourceAlpha"
                radius="2"
                result="effect1_dropShadow_10174_96687"
              />
              <feOffset dx="1" dy="1" />
              <feGaussianBlur stdDeviation="1.5" />
              <feColorMatrix values="0 0 0 0 0.482891 0 0 0 0 0.482891 0 0 0 0 0.482891 0 0 0 1 0" />
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_10174_96687"
              />
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_10174_96687"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>,
    ),
  });
};
